import { APP_BASE_PATH, APPLY_FDR_URL } from '../../../../common/constants'
import { recommendedReadsData } from '../../consts'

const { faq, whyWereBetter, testimonials } = recommendedReadsData
const TITLE = 'What Our Debt Relief Program Does | Freedom Debt Relief'
const DESCRIPTION =
  'Want to know how to reduce your debt and be debt free? Freedom Debt Relief’s program customizes an affordable solution to help you put debt in the past.'
const URL = `${APP_BASE_PATH()}/how-it-works/`

export const howItWorksData = {
  seo: {
    title: TITLE,
    description: DESCRIPTION,
    canonical: URL,
    openGraph: {
      title: TITLE,
      description: DESCRIPTION,
      url: URL,
      images: [
        {
          url: `${APP_BASE_PATH()}/next-assets/brand-pages/heros/how-it-works.webp`,
        },
      ],
    },
  },
  heroData: {
    title: 'How Freedom Debt Relief works',
    id: 'howItWorksHero',
    description: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'End your debt stress with a proven, affordable debt relief\n program. Our consultants will guide you through every step. ',
          marks: [],
        },
      ],
    },
    provenResult: {
      list: [
        { quantity: '$20 billion+', tagline: 'in debt resolved' },
        { quantity: '1 million+', tagline: 'clients served' },
        { quantity: '22 years', tagline: 'as a trusted leader' },
      ],
    },
    img: {
      src: '/next-assets/brand-pages/heros/how-it-works.webp',
      alt: 'happy Freedom Debt Relief woman client',
    },
  },
  brandData: {
    tagline: 'How it works',
    title: '5 simple steps to debt relief',
    description: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'Freedom Debt Relief’s program is not a loan and does not charge signup fees. We talk to your creditors about settling your\n debts for less than you owe in as little as 24-48 months.* You don’t owe us a thing until we negotiate an acceptable settlement.',
          marks: [],
        },
      ],
    },
    hasLink: true,
    link: {
      name: 'Find out which debts apply',
      hasArrowIcon: true,
    },
    button: {
      name: 'Get your free evaluation',
      href: APPLY_FDR_URL(),
      showInMobile: false,
    },
    isLeadId: true,
  },
  kindOfDebt: {
    headLine: 'What kind of debt do you have?',
    info: {
      nodeType: 'paragraph',
      data: {},
      content: [
        {
          nodeType: 'text',
          value: 'Our',
          marks: [],
          data: {},
        },
        {
          nodeType: 'hyperlink',
          data: {
            uri: '/debt-relief-program/',
            title: 'What kind of debt do you have?',
          },
          content: [
            {
              nodeType: 'text',
              value: ' debt relief program ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'text',
          value:
            'can help you with unsecured debts, or debt that is not backed by collateral like a house or car.',
          marks: [],
          data: {},
        },
      ],
    },
    debts: [
      {
        title: 'Debts we can help with',
        debtTypes: [
          'Credit card debt',
          'Medical debt',
          'Personal loan debt',
          'Private student loan debt',
          'Department store credit card ',
          'Collections',
          'Repossessions',
          'Lines of credit',
          'Payday loans',
        ],
      },
      {
        title: 'Debts we can’t help with',
        debtTypes: [
          'Taxes',
          'Utility bills',
          'Lawsuits',
          'Secured loans (HELOC, auto, etc.)',
          'Federal student loans',
        ],
      },
    ],
    contact:
      'Still not sure if your debt is eligible for debt relief? Give us a call and one of our debt consultants will guide you.',
  },
  fiveSteps: [
    {
      id: 'debt-step-one',
      stepTitle: 'Start with a free debt evaluation',
      stepDescription:
        'We’ll discuss your debt, goals, and options. We’ll come up with a debt relief plan that works with your income and expenses.',
      img: {
        desktop: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-one.webp',
          alt: 'First step',
        },
        mobile: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-one.webp',
          alt: 'First step mobile',
        },
      },
    },
    {
      id: 'debt-step-two',
      stepTitle: 'Make one low monthly deposit',
      stepDescription: `Instead of struggling to make payments to your creditors, you can potentially free up more cash by choosing to set aside those funds in a dedicated account used to fund settlements.`,
      img: {
        desktop: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-two.webp',
          alt: 'Add money desktop',
        },
        mobile: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-two.webp',
          alt: 'Add money mobile',
        },
      },
    },
    {
      id: 'debt-step-three',
      stepTitle: 'Approve your settlement offers',
      stepDescription:
        'Our expert team negotiates with your creditors on your behalf. You’ll get notified online and on your phone when new settlement offers come in.',
      img: {
        desktop: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-three.webp',
          alt: 'Approve offer desktop',
        },
        mobile: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-three.webp',
          alt: 'Approve offer mobile',
        },
      },
    },
    {
      id: 'debt-step-four',
      stepTitle: 'Pay off your enrolled debt',
      stepDescription:
        'Once you have authorized a settlement, payments will be made directly from your dedicated account to the creditor.',
      img: {
        desktop: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-four.webp',
          alt: 'Pay debt desktop',
        },
        mobile: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-four.webp',
          alt: 'Pay debt mobile',
        },
      },
    },
    {
      id: 'debt-step-five',
      stepTitle: 'Focus on your life again',
      stepDescription:
        'When you successfully complete the debt relief program, you’ll be free of the debts you enrolled so you can move forward with your life.',
      showButton: true,
      isLeadCta: true,
      img: {
        desktop: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-five.webp',
          alt: 'Focus on your life desktop',
        },
        mobile: {
          src: '/next-assets/brand-pages/how-it-works/desktop/step-five.webp',
          alt: 'Focus on your life mobile',
        },
      },
    },
  ],

  recommendedReadsData: [whyWereBetter, testimonials, faq],

  bottomSectionData: {
    title: `Find out how Freedom Debt Relief can work for you`,
    list: [
      'Reduce what you owe',
      'Pay less each month',
      'Get rid of debt faster than making minimum payments',
    ],
    image: {
      src: '/next-assets/brand-pages/how-it-works/footer-person.png',
      alt: 'older male Freedom Debt Relief client',
    },
    isDark: true,
  },
}
export const heroVariationData = {
  subHeadLine: {
    paragraph: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'End your debt stress with a proven, affordable debt relief \n program.Our consultants will guide you through every step. ',
          marks: [],
        },
      ],
    },
    bullets: [
      'Get a free assessment and check eligibility for one low monthly payment',
      'Our team negotiates for you to reduce your debt',
      `Approve your settlement offers and get rid of your debt`,
    ],
  },
  ctaButton: {
    shortText: 'Get debt help now',
    longText: 'Get a free debt assessment',
    btnUrl: APPLY_FDR_URL(),
  },
  trustMarkers: {
    multiple: [
      { quantity: '$20 billion+', tagline: 'in debt resolved' },
      { quantity: '1 million+', tagline: 'clients served' },
      { quantity: '22 years', tagline: 'as a trusted leader' },
    ],
  },
  provenResults: [
    { quantity: '1 million+', tagline: 'clients served' },
    { quantity: '22 years', tagline: 'as a trusted leader' },
    { quantity: '$20 billion+', tagline: 'in debt resolved' },
  ],
}

export const heroMapVariations = {
  '1_control': {
    subHeadLineParagraph: true,
    ctaTextShort: true,
    trustMarkersMultiple: true,
  },
  '2_paragraph_short_trustpilot': {
    subHeadLineParagraph: true,
    ctaTextShort: true,
    provenResults: true,
    trustMarkersTrustPilot: true,
  },
  '3_paragraph_long_multiple': {
    subHeadLineParagraph: true,
    ctaTextShort: false,
    trustMarkersMultiple: true,
  },
  '4_paragraph_long_trustpilot': {
    subHeadLineParagraph: true,
    ctaTextShort: false,
    provenResults: true,
    trustMarkersTrustPilot: true,
  },
  '5_bullet_short_multiple': {
    subHeadLineBullet: true,
    ctaTextShort: true,
    trustMarkersMultiple: true,
  },
  '6_bullet_short_trustpilot': {
    subHeadLineBullet: true,
    ctaTextShort: true,
    provenResults: true,
    trustMarkersTrustPilot: true,
  },
  '7_bullet_long_multiple': {
    subHeadLineBullet: true,
    ctaTextShort: false,
    trustMarkersMultiple: true,
  },
  '8_bullet_long_trustpilot': {
    subHeadLineBullet: true,
    ctaTextShort: false,
    provenResults: true,
    trustMarkersTrustPilot: true,
  },
}
